<div class="forecast-kpi-cards">
  @for (widget of widgets; track widget.title) {
    <div class="forecast-kpi-card">
      <mds-icon class="forecast-kpi-card__icon" [key]="widget.icon" [width]="27" [height]="27" [pathColors]="['#8a9da8']"></mds-icon>
      <span class="forecast-kpi-card__title">{{ widget.title }}</span>
      <div class="forecast-kpi-card__value-row">
        <span class="forecast-kpi-card__value">{{ widget.value }}</span>
        @if (widget.unit) {
          <span class="forecast-kpi-card__unit">{{ widget.unit }}</span>
        }
      </div>
      <span class="forecast-kpi-card__subtitle">{{ widget.subtitle }}</span>
    </div>
  }
</div>
